import { z } from 'zod';
import { zodRemoveNullable } from '@/lib/zod-helper';
import {
  formCodeDtoSchema,
  queryTemplateResSchema,
} from '~/generated/smart-form/zod-schema';
import { formTemplateStatusSchema } from './form-status-schema';

const categorySchema = zodRemoveNullable(formCodeDtoSchema);

export const queryTemplateParamBaseSchema = z.object({
  categoryId: z.string().optional(),
  typeId: z.string().min(1),
  specialtyId: z.string().optional(),
});

export const queryTemplateResponseSchema = z.array(
  zodRemoveNullable(queryTemplateResSchema, {
    excludeMask: { modifyUserName: true, modifyDatetime: true },
  }).extend({
    category: categorySchema,
    type: categorySchema,
    specialty: categorySchema,
    status: formTemplateStatusSchema,
  }),
);

export type QueryTemplateData = z.infer<typeof queryTemplateResponseSchema>;
